<template>
    <div class="text-center ">

        <v-dialog v-model="dialog" width="1000" relative persistent>

            <!--    cityDefinition-->
            <div class="d-none" style=" position: fixed; z-index: 999; width: 200px; ">
                <div id="map" style="width: 600px; height: 400px" class="cityDefinition"></div>

                <input type="text" id="cityDefinition" v-model="cityDefinition">
                <button @click="find__button">cityDefinitionF</button>

            </div>
            <!--    cityDefinition end-->

            <div class="d-flex" v-if="terms_of_use == false">
                <v-btn icon @click="dialog = false" dark class="ml-auto dialog__close ">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>

            <v-card>
                <v-card-title class="headline">
                    <slot name="title" v-if="terms_of_use == false">
                        <div class="h2_title">Мы Вам перезвоним</div>
                    </slot>
                    <div class="terms_of_use__title " v-if="terms_of_use">
                        <div class="h2_title">Условия использования персональных данных</div>
                    </div>
                </v-card-title>

                <v-card-text>
                    <div class="terms_of_use terms_of_use_custom" v-if="terms_of_use">

                        <!--контент можно обернуть абзацы в div с v-html=""-->

                        <div v-html="terms"></div>
                        <!--контент можно обернуть абзацы в div с v-html="" end-->


                        <div class="mt-30">
                            <button class="px-30 btn_bordered "
                                    @click="terms_of_use = false">
                                Прочитал
                            </button>

                        </div>

                    </div>
                    <slot name="content">
                        <v-form ref="form" v-if="terms_of_use == false" @submit.prevent="" class="form_upload mainForm"
                                name="landingForm"
                                v-model="valid"
                                lazy-validation>
                            <div class="row mx-0 my-0 ">
                                <div class="col-12 py-0">
                                    <div class="form_upload__item">
                                        <label v-if="language == 'ru'" for="name">ФИО <span
                                                class="red"> *</span></label>
                                        <label v-else-if="language == 'en'" for="name">Full name <span
                                                class="red"> *</span></label>
                                        <v-text-field v-if="language == 'ru'"
                                                      v-model="name"
                                                      :rules="nameRulesRu"
                                                      required=""
                                                      solo
                                                      id="name"

                                        ></v-text-field>
                                        <v-text-field v-else-if="language == 'en'"
                                                      v-model="name"
                                                      :rules="nameRules"
                                                      required=""
                                                      solo
                                                      id="name"
                                        ></v-text-field>

                                    </div>
                                </div>
                                <div class="col-12 py-0">
                                    <div class="form_upload__item item_tel position-relative">
                                        <label for="tel">Телефон <span class="red"> *</span></label>
                                        <!--                    oninput="this.value = this.value.replace(/[^\d]/g,'');"-->
                                        <!--                    class="tel_input-->
                                        <v-text-field
                                                v-model="tel_input"
                                                :rules="tel_inputRulesRu"
                                                required
                                                solo
                                                id="tel"
                                                oninput="this.value = this.value.replace(/[^\d]/g,'');"
                                                class=" pl-0"
                                                v-mask="'# ### ###-##-##'"

                                        ></v-text-field>


                                        <!--                    <v-select-->
                                        <!--                        :items="tel_items"-->
                                        <!--                        :menu-props="{ contentClass: 'wrap_selfilter' }"-->
                                        <!--                        item-value="sel_id"-->
                                        <!--                        v-model="defaultSelectedTel.sel_id"-->
                                        <!--                        solo-->
                                        <!--                        class="tel_sel__btn d-flex align-items-center"-->
                                        <!--                        append-icon="mdi mdi-chevron-down"-->
                                        <!--                    >-->
                                        <!--                      <template slot="selection" slot-scope="data">-->
                                        <!--                        <img :src="data.item.icon"></img>-->
                                        <!--                        <span class="tel_kod">{{ data.item.kod }}</span>-->
                                        <!--                      </template>-->

                                        <!--                      <template slot="item" slot-scope="data">-->
                                        <!--                        <img class="pr-2" :src="data.item.icon"></img>-->
                                        <!--                        <span v-if="language == 'ru'">{{ data.item.name }}</span>-->
                                        <!--                        <span v-else-if="language == 'en'">{{ data.item.eng_name }}</span>-->
                                        <!--                      </template>-->
                                        <!--                    </v-select>-->

                                    </div>
                                </div>


                                <div class="col-12 py-0">
                                    <div class="form_upload__item">
                                        <label for="city">Город <span class="red"> *</span></label>
                                        <v-text-field
                                                v-model="city"
                                                :rules="cityRulesRu"
                                                required
                                                solo
                                                id="city"
                                                class=""
                                        ></v-text-field>

                                    </div>
                                </div>


                                <div class="col-12 py-0">
                                    <div class="form_upload__item">
                                        <label for="email">E-mail <span class="red"> *</span></label>
                                        <v-text-field v-if="language == 'ru'"
                                                      v-model="email"
                                                      :rules="emailRulesRu"
                                                      required
                                                      solo
                                                      id="email"
                                        ></v-text-field>
                                        <v-text-field v-else-if="language == 'en'"
                                                      v-model="email"
                                                      :rules="emailRules"
                                                      required
                                                      solo
                                                      id="email"
                                        ></v-text-field>
                                    </div>
                                </div>


                                <div class="col-12 py-0">
                                    <div class="form_upload__item item_tel position-relative">
                                        <label v-if="language == 'ru'">Выберите удобный вид связи</label>
                                        <label v-else-if="language == 'en'">Choose a convenient way of
                                            communication</label>
                                        <v-select v-if="language == 'ru'"
                                                  :items="type_appealRu"
                                                  :menu-props="{ contentClass: 'wrap_selfilter' }"
                                                  item-value="sel_id"
                                                  v-model="type_appeal_sel.sel_id"
                                                  solo
                                                  class=" d-flex align-items-center"
                                                  append-icon="mdi mdi-chevron-down"

                                        >

                                            <template slot="selection" slot-scope="data">
                                                <img :src="data.item.icon"></img>
                                                <span class="pl-2">{{ data.item.name }}</span>
                                                <input type="text" class="d-none" id="TypeOfCommunication"
                                                       :value="data.item.name">
                                            </template>

                                            <template slot="item" slot-scope="data">
                                                <img :src="data.item.icon"></img>
                                                <span class="pl-2">{{ data.item.name }}</span>
                                            </template>
                                        </v-select>
                                        <v-select v-else-if="language == 'en'"
                                                  :items="type_appeal"
                                                  :menu-props="{ contentClass: 'wrap_selfilter' }"
                                                  item-value="sel_id"
                                                  v-model="type_appeal_sel.sel_id"
                                                  solo
                                                  class=" d-flex align-items-center"
                                                  append-icon="mdi mdi-chevron-down"

                                        >

                                            <template slot="selection" slot-scope="data">
                                                <img :src="data.item.icon"></img>
                                                <span class="pl-2">{{ data.item.name }}</span>
                                            </template>

                                            <template slot="item" slot-scope="data">
                                                <img :src="data.item.icon"></img>
                                                <span class="pl-2">{{ data.item.name }}</span>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>


                                <div class="col-12 col-md-12 py-0">
                                    <!-- SmartCaptcha -->
                                    <div id="captcha-container-footer" :class="captchaPassed ? '':'error-captcha'"
                                         class="w-100 mb-2"></div>

                                    <!--                  <div class="form_upload__item d-flex flex-column mb-5">-->
                                    <!--                    <v-checkbox v-if="language == 'ru'"-->
                                    <!--                                v-model="checkbox"-->
                                    <!--                                :rules="[(v) => !!v || 'Вы должны подтвердить прочтение соглашения!']"-->
                                    <!--                                required-->
                                    <!--                                color="red"-->
                                    <!--                                class="mt-5 mb-5"-->
                                    <!--                    >-->
                                    <!--                      <template v-slot:label>-->
                                    <!--                        Я подтверждаю, что прочитал <a href="#" @click="terms_of_use = true" class="mx-1">соглашение</a>-->
                                    <!--                        и согласен с ним.-->
                                    <!--                      </template>-->
                                    <!--                    </v-checkbox>-->
                                    <!--                    <div>-->

                                    <!--                      <button v-if="language == 'ru'" :disabled="!valid" class=" px-30 btn_bordered mw-100"-->
                                    <!--                              @click="validate">-->
                                    <!--                        Отправить-->
                                    <!--                      </button>-->

                                    <!--                    </div>-->
                                    <!--                  </div>-->

                                    <div class="form_upload__item  mt-30">
                                        <v-checkbox
                                                v-model="checkbox"
                                                :rules="[(v) => !!v || 'Это обязательный пункт']"
                                                required
                                                color="red"
                                        >
                                            <template v-slot:label>
                                                <div class="customLabelForm">
                                                    Я выражаю согласие с <a href="javascript:void(0);"
                                                                            @click="terms_of_use = true">условиями
                                                    использования</a> моих персональных данных для обработки данного
                                                    обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,
                                                    Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,
                                                    этаж 2), я ознакомлен и выражаю согласие с
                                                    <a :href="policy" @click="linkOpen(policy)">Политикой
                                                        конфиденциальности</a> и <a :href="agreement"
                                                                                    @click="linkOpen(agreement)">Пользовательским
                                                    соглашением.</a>
                                                </div>
                                            </template>
                                        </v-checkbox>
                                        <!--                    :rules="[(v) => !!v || 'Это обязательный пункт']"-->
                                        <!--                    required-->
                                        <v-checkbox
                                                v-model="consentToInform"

                                                color="red"
                                                class="mt-0"
                                        >
                                            <template v-slot:label>
                                                <div class="customLabelForm">
                                                    Я выражаю согласие на информирование меня о продуктах, акциях,
                                                    выгодных предложениях, новостях
                                                    ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская
                                                    область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2) и
                                                    партнеров.
                                                </div>
                                            </template>
                                        </v-checkbox>

                                        <div class="btn_form d-flex align-items-center justify-content-end mb-35">
                                            <v-btn class="px-30 btn_red w-mc" @click="validate" v-if="language == 'ru'"
                                                   :disabled="!valid">
                                                Отправить
                                            </v-btn>
                                            <!--                      <button v-if="language == 'ru'" :disabled="!valid" class=" px-30 btn_bordered mw-100"&ndash;&gt;-->
                                            <!--                              @click="validate">-->
                                            <!--                        Отправить-->
                                            <!--                      </button>-->

                                            <!--            <v-btn color="error" class="mr-4" @click="reset"> Reset Form</v-btn>-->

                                            <!--            <v-btn color="warning" @click="resetValidation"> Reset Validation</v-btn>-->
                                        </div>
                                    </div>


                                </div>


                            </div>

                        </v-form>
                    </slot>
                </v-card-text>

            </v-card>
        </v-dialog>


    </div>
</template>

<script>


import {debounce} from "../../debounce";
import {mask} from 'vue-the-mask';

export default {
    delimiters: ["${", "}"],
    directives: {mask},
    props: {
        lang: String,
        cities: String | Number | Boolean | Object,
        page: String,
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
    },
    data() {
        return {
            captchaPassed: false,
            cityDefinition: "",

            id: "",
            dialog: false,
            terms_of_use: false,

            language: this.lang,

            valid: true,

            name: "",
            nameRules: [
                (v) => !!v || "Name is required",
                (v) => (v && v.length >= 3) || "Name must be less than 3 characters",
            ],
            nameRulesRu: [
                (v) => !!v || "Поле 'Имя' не может быть пустым",
                (v) => (v && v.length >= 3) || "Поле 'Имя' не можети быть меньше 3 символов",
            ],

            city: "",
            cityRulesRu: [
                (v) => !!v || "Поле 'Город' не может быть пустым",
                (v) => (v && v.length >= 3) || "Поле 'Город' не можети быть меньше 3 символов",
            ],

            email: "",
            emailRules: [
                (v) => !!v || "E-mail is required",
                (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
            emailRulesRu: [
                (v) => !!v || "E-mail обязателен для заполнения",
                (v) => /.+@.+\..+/.test(v) || "E-mail заполнен неправильно",
            ],

            type_appealRu: [
                {
                    sel_id: 0,
                    name: "Звонок",
                    icon: "/local/templates/international/img/svg/Telefone.svg",

                },
                {
                    sel_id: 1,
                    name: "Почта",
                    icon: "/local/templates/international/img/svg/email.svg",
                },
                {
                    sel_id: 2,
                    name: "Telegram",
                    icon: "/local/templates/international/img/svg/telegramm.svg",
                },
                {
                    sel_id: 3,
                    name: "WhatsApp",
                    icon: "/local/templates/international/img/svg/watsapp.svg",
                },
                {
                    sel_id: 4,
                    name: "Viber",
                    icon: "/local/templates/international/img/svg/viber.svg",
                },
            ],
            type_appeal: [
                {
                    sel_id: 1,
                    name: "Phone",
                    icon: "/local/templates/international/img/svg/Telefone.svg",

                },
                {
                    sel_id: 2,
                    name: "E-mail",
                    icon: "/local/templates/international/img/svg/email.svg",
                },
                {
                    sel_id: 3,
                    name: "Telegram",
                    icon: "/local/templates/international/img/svg/telegramm.svg",
                },
                {
                    sel_id: 4,
                    name: "WhatsApp",
                    icon: "/local/templates/international/img/svg/watsapp.svg",
                },
                {
                    sel_id: 5,
                    name: "Viber",
                    icon: "/local/templates/international/img/svg/viber.svg",
                },
            ],
            type_appeal_sel: {
                sel_id: 0,
            },

            tel_select: null,
            tel_items: [
                {
                    sel_id: 0,
                    name: "Россия",
                    eng_name: "Russia",
                    icon: "/local/templates/international/img/FlagRossii.svg",
                    kod: "+7",
                },
                // {
                //   sel_id: 1,
                //   name: "Польша",
                //   eng_name: "Poland",
                //   icon: "/local/templates/international/img/FlagPaulshi.svg",
                //   kod: "+2",
                // },
                {
                    sel_id: 1,
                    name: "Казахстан",
                    eng_name: "Kazakhstan",
                    icon: "/local/templates/international/img/FlagKazakhstana.svg",
                    kod: "+7",
                },
            ],

            defaultSelectedTel: {
                sel_id: 0,
            },

            tel_input: "",
            tel_inputRules: [
                (v) => !!v || "Phone is required",
                (v) => /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/.test(v) || "Phone must be valid",
            ],
            tel_inputRulesRu: [
                (v) => !!v || "Поле 'Телефон' обязательно для заполнения",
                // (v) => /^\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(v) || "Телефон заполнен неправильно",
                // (v) => /^[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/.test(v) || "Телефон заполнен неправильно",
            ],

            checkbox: false,
            consentToInform: false,

        };
    },
    methods: {
        linkOpen(url) {
            window.open(url, '_blank');
        },
        // Captcha
        initCaptcha() {
            window.smartCaptcha.render('captcha-container-footer', {
                sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
                callback: this.onCaptchaSuccess,
            });
        },
        onCaptchaSuccess(token) {
            this.captchaPassed = true;
            this.form.captchaToken = token;
        },
        // Captcha end
        find__button() {
            var VueObject = this;
            // console.log("find__button")
            $.ajax({
                "type": "POST",
                "url": "/ajax/nearest_city.php",
                "data": {"city_name": VueObject.city, "ajaxPost": "Y"},
                "dataType": "JSON",
                "success": function (result) {
                    console.log(result);
                    console.log(result.COORDS);
                    if (result.LAT == 0 && result.LON == 0) {
                        VueObject.cityDefinition = "Город не найден"
                    } else {
                        VueObject.cityDefinitionF([result.LAT, result.LON]);
                        // console.log([result.LAT, result.LON])
                    }
                },
                "error": function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                },
            });

        },
        cityDefinitionF(coords = [55.73, 37.75]) {

            var VueObject = this;
            ymaps.ready(init);
            var curCoordinates = coords;

            $.each(VueObject.cities, function (index, value) {
                VueObject.cities[index].geometry.coordinates = [VueObject.cities[index].properties.latitude, VueObject.cities[index].properties.longitude];
            });

            function init() {
                $("#map").html("");
                var map = new ymaps.Map("map", {
                    center: curCoordinates,
                    zoom: 7
                }); // Установили центр карты в выбранный город
                var result = ymaps.geoQuery({
                    type: 'FeatureCollection',
                    // features: <? print_r(str_replace(array("\"[", "]\""), array("[", "]"), json_encode($arCities))); ?>
                    features: VueObject.cities,
                }).addToMap(map);
                // Запилили точки на карту
                // console.log(result);
                result.then(function () {
                    // console.log("HERE");
                    var closestObject = result.getClosestTo(curCoordinates);
                    if (closestObject) {
                        if (parseInt(closestObject["properties"]["_data"]["id"]) > 0) {
                        }
                        closestObject.balloon.open(); // Находим и отрываем ближайшую

                        VueObject.cityDefinition = closestObject["properties"]["_data"]["crmId"];
                        console.log(closestObject["properties"]["_data"]["crmId"]);

                    }
                });
            }
        },
        validate() {
            if (!this.$refs.form.validate()) return false;
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }

            var VueObject = this;

            function getId() {
                VueObject.id = VueObject.$store.state.idMaterial;
            }


            // let newTel = VueObject.tel_input;
            // if (newTel[0] === '8') {
            //   newTel = newTel.slice(1); // если первая цифра 8, удаляем её
            // }

            let newTel = VueObject.tel_input;
            if (newTel[0] === '7') {
                newTel = "+ " + newTel; // если первая цифра 7, добавляем +
            }

            console.log(newTel);

            setTimeout(getId, 100);
            // ym(88483883, 'reachGoal', 'clickButton', {city: VueObject.city});
            $.ajax({
                "type": "POST",
                "url": "/ajax/footer_form.php",
                "data": {
                    "ajaxPost": "Y",
                    "name": VueObject.name,
                    "phone": newTel,
                    "email": VueObject.email,
                    "city": VueObject.city,
                    "type": VueObject.type_appeal[VueObject.type_appeal_sel.sel_id]["name"],
                    "elId": VueObject.id,
                    "page": VueObject.page,
                },
                "success": function (res) {

                    console.log(res);
                    console.log(VueObject.id);
                    $(".text_result").slideDown(300);
                    $(".text_result").delay(2000).slideUp(300);
                    // createObject();
                    setTimeout(function () {
                        VueObject.dialog = false;
                    }, 2000);


                    // jQuery(document).ready(initLanding);

                    // VueObject.reset();
                    return false;

                },
                "error": function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                }
            });

        },
        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },
        modal_open(event) {

            var VueObject = this;
            let id = setTimeout(function () {
                VueObject.id = VueObject.$store.state.idMaterial;
            }, 100);

            if (this.dialog) {
                this.dialog = false;
            } else {
                this.dialog = true;
                this.$nextTick(function () {
                    this.initCaptcha();
                });
            }


        },
    },
    watch: {
        city: debounce(function (newVal) {
            this.debouncedInput = newVal;
            this.find__button();
        }, 1000),

        captchaPassed() {
            // this.sendForm();
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
        },
    }


};
</script>
<style lang="scss">
@import "../../theme/_variable.scss";

.contents_modal__content {
  overflow-y: scroll;
}

.mainForm {
  overflow: auto;
  max-height: 60vh;
}

.terms_of_use {
  padding: 30px 30px;
  padding-top: 0;
    
    @media (max-width: 425px) {
        
    }

  & a {
    text-decoration: underline transparent;
    transition: all 0.2s ease;

    &:hover {
      text-decoration: underline #FA4237;
    }
  }
}

.terms_of_use_custom {
  p {
    color: rgb(40, 40, 40);
    font-family: "RobotoRegular";
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: left;
  }
}

body .v-dialog {
  -webkit-box-shadow: none;
  box-shadow: none;
  padding-right: 32px;
  overflow-y: unset;
  width: 675px !important;

  & .v-card > .v-card__title {
    padding: 60px 30px 0;
  }

  & .v-sheet.v-card {
    border-radius: 20px;
  }

  & .tel_input .v-input__slot {
    padding-top: 4px !important;
  }

  & .form_upload__item label {
    font-size: 18px;
  }

  .dialog__close {
    cursor: pointer;
  }
}

.dialog__close {
  right: -20px;
  position: relative;
  top: 15px;
  z-index: 1;
  background: #282828;
}

.v-dialog > .v-card > .v-card__text {
  padding: 0 !important;
  padding-top: 60px !important;
  padding-bottom: 30px !important;
}

</style>
